import {
  CANADA_COUNTRY_CODE,
  hasAlphabeticCharacter,
  IRegistrationAddress,
  POSTAL_CODE_REGEX,
  US_COUNTRY_CODE,
} from '@agco-onedigital/ecosystem-lib-frontend-utils';

export const isAddressFormSubmitable = (address: IRegistrationAddress) => {
  return (
    !!address.postalCode?.trim() &&
    POSTAL_CODE_REGEX.test(address.postalCode) &&
    !!address.addressLine1 &&
    hasAlphabeticCharacter(address.addressLine1) &&
    !!address.city &&
    hasAlphabeticCharacter(address.city) &&
    !!address.country &&
    ((address.country !== US_COUNTRY_CODE && address.country !== CANADA_COUNTRY_CODE) || !!address.state)
  );
};
